/* eslint-disable react-hooks/exhaustive-deps */
import { getSelf } from '@modules/auth/auth.Dux'
import MDBanner from '@modules/core/components/MD.Banner'
import SelectI18nLanguage from '@modules/i18n/SelectI18nLanguage'
import React, { useState, useEffect } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux' //mapStateToProps
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import { WORKPLACE_PROD_URL, WORKPLACE_DEV_URL, MAIL_TO } from '../../constants/urlConstants'
import ConsultationsApiClient from '../../Services/Consultations'
import history from '../../Services/History'
import { adminSignInSuccess } from './auth.Dux'
import SignInWrapper from './signinWrapper'
import { checkAutoLoginUser } from '../../../src/Services/Autologin'
import { useAuth } from '@/core/auth/useAuth'

const SignIn = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const { isAuthenticated } = useSelector((state) => getSelf(state))
  const dispatch = useDispatch()
  const authService = useAuth()

  useEffect(() => {
    let user = checkAutoLoginUser(window.location.search)
    if (user) {
      ConsultationsApiClient.updateHeaders({
        Authorization: `${user.token_type} ${user.access_token}`,
      })
      dispatch(adminSignInSuccess(user))
    }
  }, [])

  const login = async () => {
    if (!email) {
      setError('no-email')
      return
    }
    if (!password) {
      setError('no-password')
      return
    }
    try {
      const loginResponse = await ConsultationsApiClient.auth.adminSignIn({
        email,
        password,
      })
      authService.save({ token: loginResponse.data.access_token })
      ConsultationsApiClient.updateHeaders({
        Authorization: `${loginResponse.data.token_type} ${loginResponse.data.access_token}`,
      })

      await dispatch(adminSignInSuccess(loginResponse.data))
      if (!!loginResponse.data.profile.must_change_password) history.push('/admin/password')
      history.push('/admin')

      //TODO: remove this setter to LocalStorage once All api calls are migrated to new services
      await localStorage.setItem('jwtToken', loginResponse.data.access_token)
    } catch (e) {
      let status = e.response?.status || true
      setError(status)
      // TODO: it doesnt allow callback
      // TODO: implement reset by token retrieved in the request
      if (status === 460) setTimeout(() => history.push(`/password/reset/`), 5000)
    }
  }

  if (isAuthenticated) {
    return <Redirect to={'/admin'} />
  }

  return (
    <SignInWrapper>
      <div id="header" />
      <h2>
        <Trans>Escribe tu email y contraseña</Trans>
      </h2>

      <input type="email" onChange={(e) => setEmail(e.target.value)} />
      <input type="password" onChange={(e) => setPassword(e.target.value)} />

      {error && <MDBanner message={error} onClose={() => setError(null)} error />}

      <div className="buttons-container">
        <button type="button" onClick={() => login()}>
          <Trans>Iniciar sesión como administrador</Trans>
        </button>
      </div>

      <p>
        <Trans>
          Pulsa <Link to={'/password/reset'}>aquí</Link>, si has olvidado tu contraseña
        </Trans>
      </p>
      <p>
        <Trans>Si tienes problemas para entrar, contactanos a</Trans>
        <a href={MAIL_TO}> soporte@meetingdoctors.com</a>
      </p>

      <a
        className="redirect"
        href={`${import.meta.env.VITE_REACT_APP_ENV === 'PRODUCTION' ? WORKPLACE_PROD_URL : WORKPLACE_DEV_URL}`}
      >
        <Trans>Ir a MeetingDoctors Workplace</Trans>
      </a>

      <SelectI18nLanguage />
    </SignInWrapper>
  )
}

export default withTranslation()(SignIn)
